// import { createContext, useContext, useState } from "react";
// import { autoTranslate } from "./autoTranslate";
// import { useSelector } from "react-redux";
 
// const TranslateContext = createContext();
 
// export function TranslateProvider({ children }) {
 
//   const reduxLang = useSelector((state) => state?.langSlice?.lang);
 
//   const langMap = {
//     english: "en",
//     french: "fr",
//     spanish: "es",
//     arabic: "ar"
//   };
 
//   const lang = langMap[reduxLang] || "en";
 
//   const [cache, setCache] = useState({});
 
//   const t = async (text) => {
 
//     if (lang === "en") return text;
 
//     if (cache[text]) return cache[text];
 
//     const translated = await autoTranslate(text, lang);
 
//     setCache((prev) => ({
//       ...prev,
//       [text]: translated
//     }));
 
//     return translated;
//   };
 
//   return (
//     <TranslateContext.Provider value={{ t, lang }}>
//       {children}
//     </TranslateContext.Provider>
//   );
// }
 
// export function useTranslate() {
//   return useContext(TranslateContext);
// }


import { createContext, useContext, useState } from "react";
import { autoTranslate } from "./autoTranslate";
import { useSelector } from "react-redux";
 
const TranslateContext = createContext();
 
export function TranslateProvider({ children }) {
 
  const reduxLang = useSelector((state) => state?.langSlice?.lang);
 
  const langMap = {
    english: "en",
    french: "fr",
    spanish: "es",
    arabic: "ar"
  };
 
  const lang = langMap[reduxLang] || "en";
 
  const [cache, setCache] = useState({});
 
  const t = async (text) => {
 
    if (lang === "en") return text;
 
    if (cache[text]) return cache[text];
 
    const translated = await autoTranslate(text, lang);
 
    setCache((prev) => ({
      ...prev,
      [text]: translated
    }));
 
    return translated;
  };
 
  return (
    <TranslateContext.Provider value={{ t, lang }}>
      {children}
    </TranslateContext.Provider>
  );
}
 
export function useTranslate() {
  return useContext(TranslateContext);
}